import Configs from '@/configs'
import { parsedContent } from '@/lib/utils'

import PeaceOfMind from '~/public/images/box-storage/Peace-of-Mind.png'
import Affordability from '~/public/images/box-storage/Affordability.png'
import Accessibility from '~/public/images/box-storage/Accessibility.png'
import FlexibleTiming from '~/public/images/box-storage/Flexible-Timing.png'

import BoxBenefit from '~/public/images/box-storage/benefits.jpg'
import golfBenefit from '~/public/images/golf-club-storage/benefits.png'
import luggageBenefit from '~/public/images/luggage-storage/benefits.png'
import skiBenefit from '~/public/images/ski-storage/benefits.png'
import snowBenefit from '~/public/images/snowboard-storage/benefits.png'

const appName = Configs.APP_NAME

export const BENEFITS = Object.freeze({
  boxStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      wrClassName: '',
      title: parsedContent(`Benefits of Box storage with ${appName}`, 'max-w-[640px]'),
      subtitle: parsedContent(
        `Make the most of your vacation in NYC by storing your Box with us. Here's why you should choose ${appName}:`,
        'max-w-[820px]'
      )
    },
    content: {
      bottomContent: parsedContent(
        `Store your moving Box with ${appName} and unlock the freedom to explore the city hassle-free.`,
        'font-semibold'
      ),
      contentWrClass: '',
      image: {
        src: BoxBenefit,
        alt: 'Benefits of Box storage'
      },
      data: [
        {
          image: {
            src: FlexibleTiming,
            alt: 'Flexible Timing'
          },
          heading: parsedContent('Flexible Timing'),
          subheading: parsedContent(
            "Whether you're ahead of schedule for your departure or have time to spare before checking into your accommodation, our Box storage service at train and bus stations allows you to optimize your itinerary without the burden of carrying your boxes."
          )
        },
        {
          image: {
            src: PeaceOfMind,
            alt: 'Peace of Mind'
          },
          heading: parsedContent('Peace of Mind'),
          subheading: parsedContent(
            'Rest assured knowing your belongings are safely stored in our monitored facilities, equipped with safety measures to ensure their safety throughout your visit.'
          )
        },
        {
          image: {
            src: Accessibility,
            alt: 'Accessibility'
          },
          heading: parsedContent('Accessibility'),
          subheading: parsedContent(
            'Our strategically located storage space facilities near major transit hubs enable you to easily drop off or pick up your bags, minimizing travel disruptions and maximizing convenience.'
          )
        },
        {
          image: {
            src: Affordability,
            alt: 'Affordability'
          },
          heading: parsedContent('Affordability'),
          subheading: parsedContent(
            'Enjoy budget-friendly rates at all our locations, making <strong>${appName}</strong> a cost-effective solution for travelers seeking convenient and reliable Box storage in NYC.'
          )
        }
      ]
    }
  },
  golfClub: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      wrClassName: '',
      title: parsedContent(`Benefits of Golf club storage with ${appName}`, ''),
      subtitle: parsedContent(
        `Make the most of your vacation in NYC by storing your Golf club with us. Here's why you should choose ${appName}'s exclusive golf club storage unit:`,
        'max-w-[820px]'
      )
    },
    content: {
      bottomContent: parsedContent(
        `<strong>Store your Golf club with ${appName} and unlock the freedom to explore the city hassle-free.</strong>`
      ),
      contentWrClass: '',
      image: {
        src: golfBenefit,
        alt: 'Benefits of storage'
      },
      data: [
        {
          image: {
            src: FlexibleTiming,
            alt: 'Flexible Timing'
          },
          heading: parsedContent('Flexible Timing'),
          subheading: parsedContent(
            "Whether you're ahead of schedule for your departure or have time to spare before checking into your accommodation, our Golf club storage service at train and bus stations allows you to optimize your itinerary without the burden of carrying your bags."
          )
        },
        {
          image: {
            src: PeaceOfMind,
            alt: 'Peace of Mind'
          },
          heading: parsedContent('Peace of Mind'),
          subheading: parsedContent(
            'Rest assured knowing your belongings are secure in our monitored facilities, equipped with safety measures to ensure their safety throughout your visit.'
          )
        },
        {
          image: {
            src: Accessibility,
            alt: 'Accessibility'
          },
          heading: parsedContent('Accessibility'),
          subheading: parsedContent(
            'Our strategically located Golf club storage facilities near major transit hubs enable you to easily drop off or pick up your bags, minimizing travel disruptions and maximizing convenience.'
          )
        },
        {
          image: {
            src: Affordability,
            alt: 'Affordability'
          },
          heading: parsedContent('Affordability'),
          subheading: parsedContent(
            `Enjoy budget-friendly rates at all our locations, making <strong>${appName}</strong> a cost-effective solution for travelers seeking convenient and reliable Golf club storage in NYC.`
          )
        }
      ]
    }
  },
  luggageStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      wrClassName: '',
      title: parsedContent(`Benefits of luggage storage with ${appName}`, ''),
      subtitle: parsedContent(
        `Make the most of your vacation in NYC by storing your luggage with us. Here's why you should choose ${appName}:`,
        'max-w-[820px]'
      )
    },
    content: {
      bottomContent: parsedContent(
        `<strong>Store your luggage with ${appName} and unlock the freedom to explore the city hassle-free.</strong>`
      ),
      contentWrClass: '',
      image: {
        src: luggageBenefit,
        alt: 'Benefits of storage'
      },
      data: [
        {
          image: {
            src: FlexibleTiming,
            alt: 'Flexible Timing'
          },
          heading: parsedContent('Flexible Timing'),
          subheading: parsedContent(
            "Our luggage storage service at train and bus stations has flexible timing. This allows you to optimize your travel experience without carrying your bags. Whether you're early for your departure or have time before checking in, we can help lighten your load."
          )
        },
        {
          image: {
            src: PeaceOfMind,
            alt: 'Peace of Mind'
          },
          heading: parsedContent('Peace of Mind'),
          subheading: parsedContent(
            "Rest assured your belongings are secure in our monitored facilities with safety measures in place while you're here."
          )
        },
        {
          image: {
            src: Accessibility,
            alt: 'Accessibility'
          },
          heading: parsedContent('Accessibility'),
          subheading: parsedContent(
            'Storage facilities near transit hubs make it easy to drop off or pick up your bags. This reduces travel hassles and increases convenience. The facilities are conveniently located for easy access.'
          )
        },
        {
          image: {
            src: Affordability,
            alt: 'Affordability'
          },
          heading: parsedContent('Affordability'),
          subheading: parsedContent(
            `Our rates are affordable at all locations. <strong>${appName}</strong> is a cost-effective option for travelers in NYC. It is convenient and reliable for luggage storage.`
          )
        }
      ]
    }
  },
  skiStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      wrClassName: '',
      title: parsedContent(`Benefits of Ski storage with ${appName}`, ''),
      subtitle: parsedContent(
        `Make the most of your vacation in NYC by storing your Ski with us. Here's why you should choose ${appName}:`,
        'max-w-[820px]'
      )
    },
    content: {
      bottomContent: parsedContent(
        `<strong>Store your Ski with ${appName} and unlock the freedom to explore the city hassle-free.</strong>`
      ),
      contentWrClass: '',
      image: {
        src: skiBenefit,
        alt: 'Benefits of storage'
      },
      data: [
        {
          image: {
            src: FlexibleTiming,
            alt: 'Flexible Timing'
          },
          heading: parsedContent('Flexible Timing'),
          subheading: parsedContent(
            "Whether you're ahead of schedule for your departure or have time to spare before checking into your accommodation, our Ski storage service at train and bus stations allows you to optimize your itinerary without the burden of carrying your bags."
          )
        },
        {
          image: {
            src: PeaceOfMind,
            alt: 'Peace of Mind'
          },
          heading: parsedContent('Peace of Mind'),
          subheading: parsedContent(
            "Be sure knowing your belongings are secure in our monitored facilities. Because they're equipped with safety measures to ensure their safety throughout your visit."
          )
        },
        {
          image: {
            src: Accessibility,
            alt: 'Accessibility'
          },
          heading: parsedContent('Accessibility'),
          subheading: parsedContent(
            'Our strategically located Ski storage facilities near major transit hubs enable you to easily drop off or pick up your bags. Thus, it minimizes travel disruptions and maximizing convenience.'
          )
        },
        {
          image: {
            src: Affordability,
            alt: 'Affordability'
          },
          heading: parsedContent('Affordability'),
          subheading: parsedContent(
            `Enjoy budget-friendly rates at all our locations, making <strong>${appName}</strong> a cost-effective solution for travelers seeking convenient and reliable Ski storage in NYC.`
          )
        }
      ]
    }
  },
  snowboardStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      wrClassName: '',
      title: parsedContent(`Benefits of Snowboard storage with ${appName}`, ''),
      subtitle: parsedContent(
        `If you are looking for a reliable and best way to store a snowboard, ShipAndStorage can be your perfect solution. Make the most of your vacation in NYC by storing your Snowboard with us. Here's why you should choose <strong>${appName}</strong>:`,
        'max-w-full'
      )
    },
    content: {
      bottomContent: parsedContent(
        `<strong>Store your snowboard with ${appName} and unlock the freedom to explore the city hassle-free.</strong>`
      ),
      contentWrClass: '',
      image: {
        src: snowBenefit,
        alt: 'Benefits of storage'
      },
      data: [
        {
          image: {
            src: FlexibleTiming,
            alt: 'Flexible Timing'
          },
          heading: parsedContent('Flexible Timing'),
          subheading: parsedContent(
            "If you're traveling and need a safe place to store your snowboard, we offer a storage service at train and bus stations. This will save you from carrying your bags around, making it easier to enjoy your trip."
          )
        },
        {
          image: {
            src: PeaceOfMind,
            alt: 'Peace of Mind'
          },
          heading: parsedContent('Peace of Mind'),
          subheading: parsedContent(
            'Rest assured knowing your belongings are secure in our monitored facilities, equipped with safety measures to ensure their safety throughout your visit.'
          )
        },
        {
          image: {
            src: Accessibility,
            alt: 'Accessibility'
          },
          heading: parsedContent('Accessibility'),
          subheading: parsedContent(
            'Our strategically located snowboard storage facilities hubs enable you to easily drop off or pick up your bags, minimizing travel disruptions and maximizing convenience.'
          )
        },
        {
          image: {
            src: Affordability,
            alt: 'Affordability'
          },
          heading: parsedContent('Affordability'),
          subheading: parsedContent(
            `Enjoy budget-friendly rates at all our locations, making <strong>${appName}</strong> a cost-effective solution for travelers seeking convenient and reliable snowboard storage in NYC.`
          )
        }
      ]
    }
  }
})
